export enum WeightTypes {
    Gram,
    MicroGram,
    MilliGram,
    CentiGram,
    DeciGram,
    DekaGram,
    HectoGram,
    KiloGram,
    MegagramOrTon,
    Grain,
    PennyWeight,
    Ounce,
    Pound,
    Carat,
    Gamma
}